/**
 * Print a PDF from the current page.
 * A hidden frame opens the browser print dialog here — no extra tab.
 */
export async function printPdfBlob(blobData, filename = 'document.pdf') {
  const blob =
    blobData instanceof Blob
      ? blobData
      : new Blob([blobData], { type: 'application/pdf' })

  if (blob.type && !blob.type.includes('pdf')) {
    const text = await blob.text()
    try {
      const parsed = JSON.parse(text)
      throw new Error(parsed.error || parsed.message || text)
    } catch (err) {
      if (err instanceof Error && err.message !== text) throw err
      throw new Error(text || 'Invalid PDF response')
    }
  }

  const url = URL.createObjectURL(blob)
  const iframe = document.createElement('iframe')
  iframe.setAttribute('title', filename)
  iframe.setAttribute('aria-hidden', 'true')
  iframe.style.position = 'fixed'
  iframe.style.right = '0'
  iframe.style.bottom = '0'
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.border = '0'
  iframe.src = url
  document.body.appendChild(iframe)

  let printed = false
  const cleanup = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url)
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe)
    }, 1000)
  }
  const triggerPrint = () => {
    if (printed) return
    printed = true
    try {
      iframe.contentWindow.focus()
      iframe.contentWindow.addEventListener('afterprint', cleanup, { once: true })
      iframe.contentWindow.print()
    } catch {
      downloadPdfBlob(blob, filename)
      cleanup()
      return
    }
    setTimeout(cleanup, 60000)
  }

  iframe.onload = () => setTimeout(triggerPrint, 300)
  setTimeout(triggerPrint, 1500)
  return { method: 'print' }
}

export function downloadPdfBlob(blobData, filename = 'document.pdf') {
  const blob =
    blobData instanceof Blob
      ? blobData
      : new Blob([blobData], { type: 'application/pdf' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.parentNode.removeChild(link)
  URL.revokeObjectURL(url)
}

export async function parseBlobErrorMessage(error, fallback = 'Request failed') {
  const data = error?.response?.data
  if (data instanceof Blob) {
    try {
      const text = await data.text()
      const parsed = JSON.parse(text)
      return parsed.error || parsed.message || fallback
    } catch {
      return fallback
    }
  }
  return error?.response?.data?.error || error?.message || fallback
}
